import { Component, OnInit } from '@angular/core'
import { AlarmAppInstallModalComponent } from 'src/app/common/modals/alarm-app-install-modal/alarm-app-install-modal.component'
import { LogService } from 'src/app/services/log/log.service'
import { ModalService } from 'src/app/services/modal/modal.service'
import { RouterService } from 'src/app/services/router/router.service'

@Component({
  selector: 'developer-note',
  templateUrl: './developer-note.component.html',
  styleUrls: ['./developer-note.component.scss'],
})
export class DeveloperNoteComponent implements OnInit {
  constructor(
    private modalService: ModalService,
    private routerService: RouterService,
    private logService: LogService
  ) {}

  ngOnInit() {}

  onClickLetter() {
    this.routerService.navigate('types-story')
  }

  async onClickAppButton() {
    const modalData = {
      title: '노트 기능은 앱 전용 기능이에요',
      description: '앱에서 모든 기능을 이용해 보세요',
      buttonText: '타입스 앱 설치하기',
      logOnClickInstall: () => {},
    }
    const dialog = await this.modalService.openDialog(
      AlarmAppInstallModalComponent,
      modalData,
      'custom-center-round-modal'
    )
    await dialog.present()
  }
}
